import React from 'react'
import { Link } from 'react-router-dom'
import DropDownButton from '@components/DropDownButton'
import { getUserInfo, logout } from '@services/auth'
import {
  Header,
  LogoWrapper,
  Nav,
  Item,
  UserActions,
  UserName,
  DropDownMenu,
} from './styles'
import { DarkLogo, Arrow } from '@icons'

const HeaderComponent = () => {
  return (
    <Header>
      <LogoWrapper>
        <DarkLogo widht={91} height={20} />
      </LogoWrapper>
      <Nav>
        <Item active={window.location.pathname === '/avaliacao'}>
          <Link to="/avaliacao">Avaliação</Link>
        </Item>
        <Item active={window.location.pathname === '/historico'}>
          <Link to="/historico">Histórico</Link>
        </Item>
      </Nav>
      <UserActions>
        <UserName>{getUserInfo().name || 'Usuário'}</UserName>
        <DropDownMenu>
          <DropDownButton
            dropdownContainerWidth="fit-content"
            noHover
            content={<Arrow />}
            actions={[
              {
                label: 'Sair',
                action: () => logout(),
              },
            ]}
          />
        </DropDownMenu>
      </UserActions>
    </Header>
  )
}

export default HeaderComponent
